<template>
  <div class="custom-range-selector">
    <v-text-field
      v-model="minValue"
      hideDetails
      persistentPlaceholder
      variant="outlined"
      density="compact"
      :disabled="disabled"
      :placeholder="minLabel"
      bgColor="#ffffff"
    />
    <span>-</span>
    <v-text-field
      v-model="maxValue"
      hideDetails
      persistentPlaceholder
      variant="outlined"
      density="compact"
      :disabled="disabled"
      :placeholder="maxLabel"
      bgColor="#ffffff"
    />
  </div>
</template>
<script>
export default {
  name: "RfCustomRangeSelector",
  props: ["model", "modelValue", "disabled", "minPlaceholder", "maxPlaceholder"],
  data() {
    return {
      min: (this.modelValue && this.modelValue[0]) || "-INF",
      max: (this.modelValue && this.modelValue[1]) || "INF",
    };
  },
  computed: {
    minValue: {
      get() {
        if (this.min === "-INF") {
          return "";
        }
        return this.min;
      },
      set(value) {
        if (!value.length) {
          this.min = "-INF";
        } else {
          this.min = value;
        }
      },
    },
    maxValue: {
      get() {
        if (this.max === "INF") {
          return "";
        }
        return this.max;
      },
      set(value) {
        if (!value.length) {
          this.max = "INF";
        } else {
          this.max = value;
        }
      },
    },
    minLabel() {
      if (this.minPlaceholder) return this.minPlaceholder;
      if (this.min === "-INF") return "Any";
      return "From";
    },
    maxLabel() {
      if (this.maxPlaceholder) return this.maxPlaceholder;
      if (this.max === "INF") return "Any";
      return "From";
    },
  },
  watch: {
    min(to) {
      this.$emit("update:modelValue", [to, this.max]);
    },
    max(to) {
      this.$emit("update:modelValue", [this.min, to]);
    },
  },
  methods: {},
};
</script>
